import Alert from 'react-bootstrap/Alert';

type Props = {
  error?: unknown;
};

function GlobalError({ error }: Props) {
  return (
    <Alert variant="danger">
      <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
      <p>{error instanceof Error ? error.message : String(error ?? '')}</p>
      <hr />
      <Alert.Link href="/">Try again</Alert.Link>
    </Alert>
  );
}

export default GlobalError;
